import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs";

export const courseProgressGraphApi = createAsyncThunk(
    'auth/CourseProgressGraph/graph',
    async (requestData, { rejectWithValue }) => {
        try {
            const { type, params } = requestData;
            const response = await AuthAxios.get(apiRoutes.courseProgressGraph(`${type}`), { params })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }
const courseProgressGraphSlice = createSlice({
    name: 'CourseProgressGraph/graph',
    initialState: { result: [], loading: false, error: null, message: "" },
    reducers: {
        resetCourseProgressGraph: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(courseProgressGraphApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(courseProgressGraphApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(courseProgressGraphApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetCourseProgressGraph } = courseProgressGraphSlice.actions;
export const courseProgressGraphReducer = courseProgressGraphSlice.reducer